import { selectors } from '../../../../state';
import { camelCase } from 'lodash-es';

export function mover(state) {
  const { current, session } = selectors;
  const { id, date, fromAddress, toAddress } = current.move(state);

  const {
    firstName,
    lastName,
    email,
    homePhone,
    cellPhone,
    uuid,
    id: userId,
  } = current.user(state);

  return {
    move: {
      id: id(state),
      date: date(state),
      fromAddress: fromAddress(state) && mapAddress(fromAddress(state)),
      toAddress: mapAddress(toAddress(state)),
    },
    user: {
      firstName: firstName(state),
      lastName: lastName(state),
      email: email(state),
      homePhone: homePhone(state),
      cellPhone: cellPhone(state),
      phone: cellPhone(state) || homePhone(state),
      uuid: uuid(state),
      id: userId(state),
    },
    sessionHeaders: {
      ...session.headers(state),
      app: 'mover',
    },
  };
}

function mapAddress({ street, apt, city, state, zip }) {
  return {
    street,
    unit: apt,
    city,
    state,
    postalCode: zip,
  };
}

const isConfirmedStatus = status =>
  ['deposit_required', 'completed', 'in_process'].includes(status);

export const electricitySubscription = providerData => {
  try {
    const { __typename, ...rest } = providerData.subscriptions;
    const subscription = Object.keys(rest)
      .map(key =>
        rest[key].map(subscription => ({
          kind: key,
          ...subscription,
        }))
      )
      .flat()
      .find(({ status }) => isConfirmedStatus(status));
    const { status } = subscription;
    return {
      orderStatus:
        status === 'deposit_required' ? 'depositRequired' : 'completed',
      ...subscription,
    };
  } catch (ex) {
    console?.error?.(ex);
    return undefined;
  }
};

export const allSubscriptions = providerData => {
  try {
    const { __typename, ...rest } = providerData.subscriptions;
    const subscriptions = Object.keys(rest)
      .map(key =>
        rest[key].map(subscription => ({
          kind: key,
          ...subscription,
        }))
      )
      .flat()
      .filter(({ status }) => isConfirmedStatus(status));
    if (subscriptions.length === 0) {
      return undefined;
    }
    const subscriptionByType = subscriptions.reduce(
      (acc, subscription) => ({
        ...acc,
        [subscription.kind]: {
          ...subscription,
          orderStatus: camelCase(subscription.status),
        },
      }),
      {}
    );
    return subscriptionByType;
  } catch (ex) {
    console.error?.(ex);
    return undefined;
  }
};
